import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from "../utils.js";
import { LangContext } from "../LangContext.jsx";

class SubscriptionInformation extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        const defaultLang = this.context || { get: () => {} }; // Asume que lang tiene un método 'get'
        this.state = {
            dossiers: [],
            storage: [],
            users: [],
        };
    }

    getPersonUsage = () => {
        axios.get("/api/usage").then((res) => {
            console.log(res.data.storage);
            this.setState((prevState) => ({
                storage: {
                    ...prevState.storage,
                    usage: res.data.storage,
                },
            }));
            this.setState((prevState) => ({
                dossiers: {
                    ...prevState.dossiers,
                    usage: res.data.dossiers,
                },
            }));
            this.setState((prevState) => ({
                users: {
                    ...prevState.users,
                    usage: res.data.users,
                },
            }));
        });
    };
    componentDidMount() {
        console.log(this.props.subscription);
        const storage = {
            limitation:
                this.props.subscription.billing_plan.limitations[1]
                    .limitation_value,
            usage: 0,
        };
        this.setState({ storage: storage });

        
        const dossiers = {
            limitation:
                this.props.subscription.billing_plan.limitations[0]
                    .limitation_value,
            usage: 0,
        };
        this.setState({ dossiers: dossiers });
        console.log('xxxxx')
        console.log(this.props.subscription.billing_plan.limitations[2].limitation_value)
        const users = {
            limitation:
                this.props.subscription.billing_plan.limitations[2]
                    .limitation_value,
            usage: 0,
        };
        this.setState({ users: users },function(){
            console.log(this.state.users)
        });
        console.log(this.state.users)
        this.getPersonUsage();
    }

    render() {
        const { lang } = this.context;
        const storageUsagePercentage =
            (this.state.storage.usage / this.state.storage.limitation) * 100;
        const dossiersUsagePercentage =
            (this.state.dossiers.usage / this.state.dossiers.limitation) * 100;

        const usersUsagePercentage =
            (this.state.users.usage / this.state.users.limitation) * 100;

        return (
            <>
            <div className="card card-custom gutter-b my-5">
                <div className="row card-body">
                    <div className="col-md-3">
                        <span className=" font-weight-bolder">Plan {this.props.subscription.billing_plan.name}</span>
                        <p className="text-muted">Expira {new Date(this.props.subscription.current_term_ends_at).toISOString().split('T')[0]}</p>
                        <a href="/pricing"  >Incrementar capacidad</a>
                    </div> 
                    <div className="col-md-3">
                        <div className="row"> 
                            <div className="col-md-8">
                                <div className="progress mt-3">
                                <div
                                    className={`progress-bar ${dossiersUsagePercentage > 90 ? 'bg-danger' : 'bg-primary'}`}
                                    role="progressbar"
                                    style={{
                                    width: `${dossiersUsagePercentage}%`,
                                    }}
                                    aria-valuenow={
                                    dossiersUsagePercentage
                                    }
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                ></div>
                                </div>
                            </div>
                        </div>
                        <p className="font-weight-bolder mb-0 mt-3">Expedientes</p>
                        {this.state.dossiers.usage} de{" "}
                        {this.state.dossiers.limitation} Expedientes
                    </div>

                    <div className="col-md-3">
                        <div className="row"> 
                            <div className="col-md-8">
                                <div className="progress mt-3">
                                <div
                                    className={`progress-bar ${usersUsagePercentage > 90 ? 'bg-danger' : 'bg-primary'}`}
                                    role="progressbar"
                                    style={{
                                    width: `${usersUsagePercentage}%`,
                                    }}
                                    aria-valuenow={
                                        usersUsagePercentage
                                    }
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                ></div>
                                </div>
                            </div>
                        </div>
                        <p className="font-weight-bolder mb-0 mt-3">Usuarios colaboradores</p>
                        {this.state.users.usage} {" "} de {" "}
                        {this.state.users.limitation} usuarios
                    </div> 
                    <div className="col-md-3">
                        <div className="row"> 
                            <div className="col-md-8">
                                <div className="progress mt-3">
                                <div
                                    className={`progress-bar ${storageUsagePercentage > 90 ? 'bg-danger' : 'bg-primary'}`}
                                    role="progressbar"
                                    style={{
                                    width: `${storageUsagePercentage}%`,
                                    }}
                                    aria-valuenow={
                                    storageUsagePercentage
                                    }
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                ></div>
                                </div>
                            </div>
                        </div>
                        <p className="font-weight-bolder mb-0 mt-3">Almacenamiento</p>
                        {this.state.storage.usage} GB de{" "}
                        {this.state.storage.limitation} de almacenamiento
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default SubscriptionInformation;

if (document.getElementById("ProvidersInvitationsPanel")) {
    ReactDOM.render(
        <SubscriptionInformation />,
        document.getElementById("SubscriptionInformation")
    );
}
